'use strict';

import {
	UPDATE_ADDON_RECOMMENDATION,
	SET_ADDON_RECOMMENDATION,
	RESET_STATE
} from './productAddonRecommendations.actions';

const defaultState = {
	data: {
		productAddonRecommendation: {}
	}
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
	case SET_ADDON_RECOMMENDATION: {
		return {
			...state,
			data: {
				productAddonRecommendation: payload
			}
		};
	}

	case UPDATE_ADDON_RECOMMENDATION: {
		return {
			...state,
			data: {
				productAddonRecommendation: {
					...state.data.productAddonRecommendation,
					...payload
				}
			}
		};
	}

	case RESET_STATE: {
		return {
			...state,
			data: {
				productAddonRecommendation: defaultState.data.productAddonRecommendation
			}
		};
	}

	default:
		return state;
	}
}

export default reducer;
